export default "__VITE_ASSET__DeH6EJzb__"